import React, { useEffect, useState } from "react";
import { isLoggedIn, DIRECTPDFDOWNLOAD } from "../../api/AuthService"
import { DIRECT_PDF_DOWNLOAD, DIRECT_GENDOC_DOWNLOAD } from "../../constant/Constants"
import { saveAs } from "file-saver"
import { useNavigate, useLocation, useParams } from "react-router-dom"

export default function Downloadpdf(props) {

   const navigate = useNavigate();
   const location = useLocation();
   const params = useParams();
   
   const downloadType = params.downloadType || location.pathname.split("/")[3] || ""
   const objectName = params.objectName || location.pathname.split("/")[4] || ""
   const [loading, setLoading] = useState(false)
   
   async function handlePDFDownload() {

      setLoading(true)
      let fileName = "download"
      fileName = `${downloadType} ${objectName}`
      DIRECTPDFDOWNLOAD(`${downloadType == "pdf" ? DIRECT_PDF_DOWNLOAD : DIRECT_GENDOC_DOWNLOAD}/${objectName}`)
         .then((response) => {
            const blob = new Blob([response.data], {
               type: "application/pdf",
            })

            let fileContents = URL.createObjectURL(blob)
            saveAs(fileContents, fileName)
            setLoading(false)
            sessionStorage.getItem("freshLogin1") ? navigate("/search") : navigate(-1);
            sessionStorage.removeItem("freshLogin1")


         })
         .catch((error) => {
            console.log("error", error)
            if (error.response && error.response.status === 422) {
               //setShow(true)
               alert(
                  "You have exceeded the limit for the day and access to any additional Part/Specification is blocked! Please contact SpecReaderExt.im@pg.com for help."
               )
            }
            else if (error.response && error.response.status === 404) {
               alert("PDF Unavailable. Please use Gendoc Link for Documents")
            }
            else if (error.response && error.response.status === 400) {
               alert("Please enter valid part name.")
            }
            else if (error.response && error.response.status === 204) {
               alert("Integration service issue. Please contact SpecReaderExt.im@pg.com for help.")
            }
            else if (error.response && error.response.status === 403) {
               alert("You do not have access to the object requested.")
            }

            else if (error.response && error.response.status === 401) {
               navigate("/")
            }
            else {
               alert("There is an issue downloading the file. Please try again later.")
               console.log(" error", error)
            }
            setLoading(false)
            sessionStorage.getItem("freshLogin1") ? navigate("/search") : navigate(-1);
            sessionStorage.removeItem("freshLogin1")
         })

   }

   useEffect(() => {
      if (!isLoggedIn("objectName", objectName, "downloadtype", downloadType)) {
         navigate("/")
      } else {
         if (downloadType && objectName) {
            handlePDFDownload() //Fetch Data from API
         }
      }
   }, [downloadType, objectName])
   
   return (
      <React.Fragment>
         {loading && (
            <h2 style={{ marginTop: "70px", textAlign: "center", color: "white" }}>
               <i className="fa fa-spinner fa-spin" style={{ marginLeft: "-4rem" }} />{" "}
               For {objectName} {downloadType} is getting downloaded, please wait...
            </h2>
         )}

      </React.Fragment>
   )
}